import {SebmGoogleMap} from './directives/google-map';
import {SebmGoogleMapInfoWindow} from './directives/google-map-info-window';
import {SebmGoogleMapMarker} from './directives/google-map-marker';
import {SebmGoogleMapRouter} from './directives/google-map-router';
import {SebmGoogleMapRouterPanel} from './directives/google-map-router-panel';

export const ANGULAR2_GOOGLE_MAPS_DIRECTIVES: any[] = [
  SebmGoogleMap, SebmGoogleMapMarker, SebmGoogleMapInfoWindow, SebmGoogleMapRouter,
  SebmGoogleMapRouterPanel
];
